import { render, staticRenderFns } from "./Corporate-Expenses.vue?vue&type=template&id=e5c7854a&scoped=true"
import script from "./Corporate-Expenses.vue?vue&type=script&lang=js"
export * from "./Corporate-Expenses.vue?vue&type=script&lang=js"
import style0 from "./Corporate-Expenses.vue?vue&type=style&index=0&id=e5c7854a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c7854a",
  null
  
)

export default component.exports